<script setup>

import { ref,defineAsyncComponent, onMounted } from 'vue';
import Konva from 'konva';

// Composants
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));

const previewUrl = ref(null);

const konvaContainerId = 'test-konva';

const fullWidth = 750; // 1500;
const fullHeight = 750; // 1500;

let stage = null;
let mainLayer = null;
let group = null;

const getNewNodeTransformer = ((node) => {
    return new Konva.Transformer({
        nodes: [ node ],
        enabledAnchors: [ 'top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right' ],
        rotationSnaps: [ 0, 90, 180, 270 ],
        // set minimum width of text
        boundBoxFunc: function (oldBox, newBox) {
            newBox.width = Math.max(30, newBox.width);
            return newBox;
        },
        // Styles
        anchorStroke: '#fe0a30',
        borderStroke: '#fe0a30',
        borderStrokeWidth: 2,
        anchorFill: '#ffffff',
        anchorCornerRadius: 20,
        anchorSize: 15,
        anchorStrokeWidth: 2
    });
});

const addImageToStage = ((imageToAdd) => {
    const imageNode = new Konva.Image({
        image: imageToAdd,
        x: 0,
        y: 0,
        draggable: true
    });

    group.add(imageNode);

    const transformer = getNewNodeTransformer(imageNode);
    mainLayer.add(transformer);
});

const initKonva = (() => {


    stage = new Konva.Stage({
        container: konvaContainerId,
        width: fullWidth,
        height: fullHeight
    });

    const clipData = {
        width: 0.8 * fullWidth, // 1200,
        height: 0.8 * fullHeight, // 1200,
    };


    mainLayer = new Konva.Layer();
    stage.add(mainLayer);

    const greyBackground = new Konva.Rect({
        x: 0,
        y: 0,
        width: stage.width(),
        height: stage.height(),
        fill: 'grey'
    });
    mainLayer.add(greyBackground);

    const page = new Konva.Rect({
        x: 0.5 * (stage.width() - clipData.width),
        y: 0.5 * (stage.height() - clipData.height),
        width: clipData.width,
        height: clipData.height,
        fill: '#fff'
    });

    mainLayer.add(page);

    group = new Konva.Group({
        x: 0.5 * (stage.width() - clipData.width),
        y: 0.5 * (stage.height() - clipData.height),
        width: clipData.width,
        height: clipData.height,
        clipFunc: ((context) => {
            context.save();
            context.rect(
                0,
                0,
                clipData.width,
                clipData.height
            );
            context.restore();
        })
    });
    mainLayer.add(group);

    const newImage = new Image();
    newImage.src = '/test-image.jpg';
    newImage.onload = (() => {
        addImageToStage(newImage);
    });
});

const refreshPreview = (async () => {

    const groupWidth = group.width();
    const groupHeight = group.height();

    const ratio = (groupWidth !== 0) ? (1200 / groupWidth) : 1;

    const url = group.toDataURL({
        x: group.x(),
        y: group.y(),
        width: group.width(),
        height: group.height(),
        pixelRatio: ratio
    });

    window.open(url);

});

onMounted(() => {
    setTimeout(() => {
        initKonva();
    }, 500);
});
</script>

<template>
    <layout>
        <button
            type="button"
            @click="refreshPreview()"
        >
            {{ $t('misc.update') }}
        </button>
        <div
            :id="konvaContainerId"
        ></div>
    </layout>
</template>
